<template>
  <button :type="nativeType" @click="handleClick" class="my-button-box">
    <slot></slot>
  </button>
</template>
<script>
// <Button1></Button1>
export default {
  name: 'Button1',
  props: {
    nativeType: {
      type: String,
      default: 'button'
    }
  },
  data () {
    return {

    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('click', evt)
    }
  },
  mounted () {

  },
  destroyed () {

  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//

// 按钮使用element组件里的样式，部分按钮居左显示
// 1、默认尺寸98x40，宽度根据文字左右间距各21px计算；字体大小14pt；圆角为4像素；第一个鼠标放上去底色变为#409ee9；
// 2、中等图标尺寸82x30，宽度根据文字左右间距13px计算；鼠标放上底色变为#0286df；
// 蒙层上两个按钮中间间距20px，单独提示的页面两个按钮中间间距40px，其他情况页面中间间距20px；
// 不可点击图标底色#0286df透明50%，文字#ffffff透明80%
.my-button-box{
  height: 40px;
  line-height: 40px;
  border: none;
  background: #0286df;
  border: 1px solid #0286df;
  padding: 0 21px;
  border-radius: 4px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  outline: none;
  &:hover{
    background: #409ee9;
    border: 1px solid #409ee9;
  }
}
</style>
